function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.1,
  cx: 50,
  cy: 50,
  r: 50,
  fill: "#15A9E1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.591 71.7727C25.204 72.3817 26.0321 72.7248 26.896 72.7277H72.9222C73.3504 72.7276 73.7744 72.6431 74.1699 72.479C74.5655 72.315 74.9249 72.0746 75.2275 71.7716C75.5302 71.4686 75.7703 71.109 75.934 70.7131C76.0977 70.3173 76.1819 69.8931 76.1817 69.4647V42.5051H23.6365V69.4647C23.6388 70.3297 23.9818 71.159 24.591 71.7727ZM65.6029 44.6923H73.1229V51.3861H65.6022L65.6029 44.6923ZM65.6029 53.2374H73.1229V59.9312H65.6022L65.6029 53.2374ZM55.8744 44.6923H63.3966V51.3861H55.8744V44.6923ZM55.8744 53.2374H63.3966V59.9312H55.8744V53.2374ZM55.8744 61.7824H63.3966V68.4755H55.8744V61.7824ZM46.148 44.6923H53.6702V51.3861H46.148V44.6923ZM46.148 53.2374H53.6702V59.9312H46.148V53.2374ZM46.148 61.7824H53.6702V68.4755H46.148V61.7824ZM36.4216 44.6923H43.9445V51.3861H36.4216V44.6923ZM36.4216 53.2374H43.9445V59.9312H36.4216V53.2374ZM36.4216 61.7824H43.9445V68.4755H36.4216V61.7824ZM26.6952 53.2395H34.2167V59.9333H26.6952V53.2395ZM26.6952 61.7846H34.2167V68.4776H26.6952V61.7846Z",
  fill: "#06455E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M76.1817 39.3969H23.6365V41.3268H76.1817V39.3969Z",
  fill: "#15A9E1"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.0402 30.1184H26.8967C26.4687 30.1182 26.0449 30.2022 25.6494 30.3659C25.2539 30.5295 24.8945 30.7694 24.5918 31.0721C24.289 31.3747 24.0488 31.734 23.8849 32.1295C23.721 32.525 23.6366 32.9489 23.6365 33.3771V37.1653H76.1817V33.3771C76.1813 32.5126 75.8377 31.6836 75.2264 31.0725C74.6152 30.4614 73.7863 30.1182 72.9222 30.1184H67.3941V34.3856C67.3941 34.7681 67.2422 35.135 66.9718 35.4055C66.7014 35.676 66.3347 35.828 65.9523 35.828H62.9143C62.725 35.828 62.5375 35.7907 62.3626 35.7182C62.1877 35.6457 62.0288 35.5394 61.895 35.4055C61.7612 35.2715 61.655 35.1125 61.5826 34.9375C61.5103 34.7625 61.473 34.575 61.4731 34.3856V30.1184H38.3464V34.3856C38.3464 34.768 38.1946 35.1348 37.9244 35.4053C37.6541 35.6758 37.2876 35.8278 36.9053 35.828H33.8659C33.6765 35.8281 33.489 35.7908 33.3141 35.7184C33.1392 35.6459 32.9802 35.5397 32.8464 35.4057C32.7125 35.2717 32.6064 35.1127 32.534 34.9376C32.4617 34.7626 32.4245 34.575 32.4247 34.3856V30.1184H29.0402Z",
  fill: "#15A9E1"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M76.1817 37.1652H23.6365V39.3967H76.1817V37.1652Z",
  fill: "#06455E"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M33.866 34.3856H36.9054V30.1184V26.3638H33.866V30.1184V34.3856Z",
  fill: "#06455E"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M62.9143 34.3856H65.9523V30.1184V26.3638H62.9143V30.1184V34.3856Z",
  fill: "#06455E"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M43.9445 44.6921H36.4216V51.3859H43.9445V44.6921Z",
  fill: "#15A9E1"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M53.6701 44.6921H46.1479V51.3859H53.6701V44.6921Z",
  fill: "#15A9E1"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M63.3972 44.6921H55.8743V51.3859H63.3972V44.6921Z",
  fill: "#15A9E1"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M73.123 44.6921H65.6023V51.3859H73.123V44.6921Z",
  fill: "#15A9E1"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M34.2175 53.2368H26.6953V59.9306H34.2175V53.2368Z",
  fill: "#15A9E1"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M43.9445 53.2368H36.4216V59.9306H43.9445V53.2368Z",
  fill: "#15A9E1"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M53.6701 53.2368H46.1479V59.9306H53.6701V53.2368Z",
  fill: "#15A9E1"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M63.3972 53.2368H55.8743V59.9306H63.3972V53.2368Z",
  fill: "#15A9E1"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M73.123 53.2368H65.6023V59.9306H73.123V53.2368Z",
  fill: "#15A9E1"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M34.2175 61.7822H26.6953V68.4753H34.2175V61.7822Z",
  fill: "#15A9E1"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M43.9445 61.7822H36.4216V68.4753H43.9445V61.7822Z",
  fill: "#15A9E1"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M53.6701 61.7822H46.1479V68.4753H53.6701V61.7822Z",
  fill: "#15A9E1"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M63.3972 61.7822H55.8743V68.4753H63.3972V61.7822Z",
  fill: "#15A9E1"
});

var SvgAppointment = function SvgAppointment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppointment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appointment.6af241c7.svg";
export { ForwardRef as ReactComponent };